<div class="feature-upload-shell">
  <div class="feature-upload-box">
    <img [src]="imageData || placeholder" alt="Feature image" />
    <label class="upload-trigger" title="Change image">
      <i class="pi pi-pencil"></i>
      <input type="file" accept=".png,.jpg,.jpeg,.webp" (change)="handleFileInput($event)" hidden />
    </label>
    <button class="remove-trigger" *ngIf="_productService.featureImage" (click)="removeImage()" title="Remove image">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <div class="feature-note">
    Set the product featured image. Only png, jpg, webP, and jpeg image files are accepted
  </div>
</div>
